import { render, staticRenderFns } from "./userEmployeesAdd.vue?vue&type=template&id=0bfb4030&scoped=true"
import script from "./userEmployeesAdd.vue?vue&type=script&lang=js"
export * from "./userEmployeesAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfb4030",
  null
  
)

export default component.exports